<template>
<svg viewBox="0 0 16 16" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-fill-stop`]" width="1em" height="1em" v-bind="$attrs"><g clip-path="url(#svg_f0530c4042__clip0_4713_276120)"><path d="M8 0.796875C11.9765 0.796875 15.2002 4.02062 15.2002 7.99707C15.2002 11.9735 11.9764 15.1973 8 15.1973C4.02355 15.1973 0.799805 11.9735 0.799805 7.99707C0.799805 4.02062 4.02355 0.796875 8 0.796875ZM7.40039 5.79688C6.84034 5.79688 6.55961 5.79726 6.3457 5.90625C6.1578 6.00208 6.00501 6.15487 5.90918 6.34277C5.80019 6.55669 5.7998 6.83741 5.7998 7.39746V8.59668C5.7998 9.15673 5.80019 9.43746 5.90918 9.65137C6.00501 9.83928 6.1578 9.99206 6.3457 10.0879C6.55961 10.1969 6.84034 10.1973 7.40039 10.1973H8.59961C9.15966 10.1973 9.44039 10.1969 9.6543 10.0879C9.84221 9.99206 9.99499 9.83928 10.0908 9.65137C10.1998 9.43746 10.2002 9.15673 10.2002 8.59668V7.39746C10.2002 6.83741 10.1998 6.55669 10.0908 6.34277C9.99499 6.15486 9.84221 6.00208 9.6543 5.90625C9.44039 5.79726 9.15966 5.79688 8.59961 5.79688H7.40039Z"/></g><defs><clipPath id="svg_f0530c4042__clip0_4713_276120"><path d="M0 0H16V16H0z"/></clipPath></defs></svg>
</template>
<script>

export default {
  name: 'IconFillStop',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
